// extracted by mini-css-extract-plugin
module.exports =  {"container":"List-module__container___qwiHm"};